import { render } from "./BreadcrumbsComponent.vue?vue&type=template&id=c45b4a96&ts=true"
import script from "./BreadcrumbsComponent.vue?vue&type=script&lang=ts"
export * from "./BreadcrumbsComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__